import levelUnlockingSystem from "../../../worldMap/levelUnlockingSystem";

const chunkToArt = (chunk: number): string => {
  return `worldmap_backgrounds/worldmap_backer${chunk + 1}`;
};

export class WorldMapGradientBacker {
  // Array of sprites. We add backgrounds to the back and tween them off.
  private sprite1: Phaser.GameObjects.Sprite;
  private sprite2: Phaser.GameObjects.Sprite;
  private shader: Phaser.GameObjects.Shader;
  private scene: Phaser.Scene;
  constructor(scene: Phaser.Scene, currentChunk: number) {
    this.scene = scene;
    this.sprite1 = scene.add.sprite(0, 0, "atlas", chunkToArt(currentChunk));
    this.sprite2 = scene.add.sprite(
      0,
      0,
      "atlas",
      chunkToArt(currentChunk + 1)
    );

    this.shader = scene.add.shader("background", 64, 64, 128, 128, [
      `worldmap_backer${currentChunk + 1}`,
    ]);
    this.sprite1.setDepth(-50).setVisible(true).setTint(0x888888);
    this.sprite2.setDepth(-60).setVisible(true).setTint(0x888888);
  }

  changeSprite(currentChunk: number) {
    if (levelUnlockingSystem.isChunkCompleted(currentChunk)) {
      this.shader.setVisible(false);
    } else {
      this.shader.setVisible(true);
    }
    this.scene.add.tween({
      targets: this.sprite1,
      duration: 400,
      alpha: { from: 1, to: 0 },
      onComplete: () => {
        this.sprite1.setFrame(chunkToArt(currentChunk));
        this.sprite1.setAlpha(1);
      },
    });
    this.shader.setChannel0(`worldmap_backer${currentChunk + 1}`);

    this.sprite2.setFrame(chunkToArt(currentChunk));
  }
}
